export const UserGroupState = _ => ({
  groups: [],
})
